<template>
    <div class="pages" :class="{ 'is-h5': isH5 }">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box" :class="{ 'is-h5': isH5 }">
            <div class="box-tit">{{ tit }}</div>
            <!-- <div class="box-txt">
                <img src="../../../static/images/img/logo.png" alt="">
                <div>{{ $t('电商购物网站') }}</div>
            </div> -->

            <div v-html="content" class="detail-html"></div>
        </div>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
    import ShortcutBar from '@/components/ShortcutBar';
    import footerBar from '@/components/footerBar';
    import leftSuspension from "@/components/leftSuspension.vue";
    import he from 'he';
    import { getconf } from '@/api/user';

    export default {
        name: 'briefIntroduction',
        components: {
            'shortcut-bar': ShortcutBar,
            'footer-bar': footerBar,
            leftSuspension,
        },
        data() {
            return {
                content: '',//简介内容
                tit: '',//标题内容
                isH5: typeof window !== 'undefined' && window.innerWidth < 768,
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.path !== from.path) {
                    // console.log(to.params.id);
                    let id = to.params.id
                    this.onInPage(id)
                }
            }
        },
        mounted() {
            this.updateIsH5();
            window.addEventListener('resize', this.updateIsH5);
            let id = this.$route.params.id;
            this.onInPage(id)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateIsH5);
        },
        methods: {
            updateIsH5() {
                this.isH5 = window.innerWidth < 768;
            },
            onInPage(id) {
                if (id == 12) {
                    this.tit = this.$t('关于我们')
                } else if (id == 15) {
                    this.tit = this.$t('简介')
                }
                this.onSystemPage(id)
            },
            /**系统单页 */
            onSystemPage(type) {
                getconf({ module: 'system' }).then(res => {
                    let data = res.data;
                    this.content = type == 12 ? data.aboutus : data.introduction;
                    // console.log(res.data);
                })
                // systemPage({ type: type }).then(res => {
                //     this.content = he.decode(res.data.content)
                //     console.log(this.content);
                // })
            }
        }
    };
</script>

<style scoped lang="scss">
    .pages {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .page-header {
        z-index: 999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }

    .page-header-placeholder {
        height: 56px;
    }

    .box {
        padding: 32px 24px;
        margin: 24px 360px 80px;
        min-height: 80vh;
        flex: 1;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 8px;

        .box-tit {
            font-size: 24px;
            font-weight: 600;
            margin: 24px 0;
        }

        .box-txt {
            display: flex;
            align-items: center;
            font-size: 14px;
            margin-bottom: 16px;

            img {
                width: 35px;
                height: 35px;
                margin-right: 12px;
            }
        }
    }

    /* PC 端内容区与首页保持一致，固定使用 1024px 页面栅格。 */
    @media (min-width: 768px) {
        .box {
            width: 1024px;
            margin: 24px auto 80px;
            box-sizing: border-box;
        }
    }

    @media (max-width: 767px) {
        .pages.is-h5 {
            overflow-x: hidden;
            width: 100%;
            background: #f5f6f8;
        }

        .page-header {
            padding-top: env(safe-area-inset-top, 0px);
        }

        .page-header-placeholder {
            height: calc(56px + env(safe-area-inset-top, 0px));
        }

        .pc-float {
            display: none;
        }

        .box.is-h5 {
            margin: 12px;
            padding: 16px 12px 24px;
            min-height: auto;
            background: #fff;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            .box-tit {
                font-size: 18px;
                margin: 0 0 12px;
            }

            .detail-html {
                font-size: 14px;
                line-height: 1.6;
                word-break: break-word;

                /deep/ img {
                    max-width: 100%;
                    height: auto;
                }

                /deep/ video {
                    max-width: 100%;
                }

                /deep/ table {
                    max-width: 100%;
                    display: block;
                    overflow-x: auto;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/ShortcutBar/briefIntroduction.vue